import React from "react";
import { PageHero, Section, OBJECTIVES, FEATURES } from "./_shared";
import { Target, ShieldCheck, Award, Calendar } from "lucide-react";

export default function About() {
  return (
    <div data-testid="mitsol-about">
      <PageHero
        eyebrow="About the Institute"
        title="Marathwada Private Industrial Training Institute, Solapur"
        sub="A G.S. Mandal initiative — established in August 1994 to serve the vocational education needs of Solapur district's rural community."
      />

      <Section>
        <div className="grid md:grid-cols-[1fr_auto] gap-10 items-start">
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-700 leading-relaxed">
              Gramaudyogik Shikshan Mandal, Chhatrapati Sambhajinagar recognised the need for quality vocational training in Solapur&apos;s rural belt and established this institute at Tuljapur Road in August 1994. Over three decades, the institute has grown into a well-equipped, all-round Industrial Training Institute delivering NCVT-accredited certification.
            </p>
            <p className="mt-4 text-slate-700 leading-relaxed">
              Today, thousands of alumni are employed in reputed manufacturing companies, government establishments, and successful self-employment ventures across Maharashtra. The institute&apos;s curriculum, examination system and certification mirror those of Government ITIs.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <FactCard icon={<Calendar />} label="Established" value="August 1994" />
              <FactCard icon={<Award />} label="Institute Code" value="426" />
              <FactCard icon={<ShieldCheck />} label="Affiliation" value="NCVT, New Delhi" />
              <FactCard icon={<Target />} label="Recognition" value="Govt. of Maharashtra" />
            </div>
          </div>

          <aside className="bg-[#FEF9F0] border-l-4 border-[#F97316] p-6 md:min-w-[280px]">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#F97316] font-bold">Address</div>
            <div className="mt-2 text-sm text-slate-800 leading-relaxed">
              Tuljapur Road, Tale Hipparga,<br />
              Ta. North Solapur,<br />
              Dist. Solapur — Maharashtra
            </div>
            <div className="mt-4 text-[10px] tracking-[0.25em] uppercase text-slate-500">Managed by</div>
            <div className="mt-1 text-sm font-semibold text-[#0F2A47]">Gramaudyogik Shikshan Mandal,<br />Chhatrapati Sambhajinagar</div>
          </aside>
        </div>
      </Section>

      {/* Objectives */}
      <div className="bg-[#0F2A47] text-white">
        <Section className="!py-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-[#F97316] font-bold">Our Objectives · संस्थेचा मुख्य उद्देश</div>
          <h2 className="font-serif text-3xl mt-2">Why we exist</h2>
          <div className="mt-8 grid md:grid-cols-2 gap-5">
            {OBJECTIVES.map((o, i) => (
              <div key={i} className="bg-white/5 border border-white/10 p-6">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#F97316] font-bold">Objective {String(i + 1).padStart(2, "0")}</div>
                <div className="mt-2 text-white/90 leading-relaxed">{o}</div>
              </div>
            ))}
          </div>
        </Section>
      </div>

      {/* Features */}
      <Section>
        <div className="text-[10px] tracking-[0.35em] uppercase text-[#F97316] font-bold">Institute Features · संस्थेची वैशिष्ठये</div>
        <h2 className="font-serif text-3xl mt-2 text-[#0F2A47]">What sets us apart</h2>
        <div className="mt-8 grid md:grid-cols-2 gap-4">
          {FEATURES.map((f, i) => (
            <div key={i} className="flex items-start gap-3 bg-white border border-slate-200 p-5">
              <div className="w-8 h-8 shrink-0 bg-[#F97316]/10 text-[#F97316] font-bold flex items-center justify-center text-sm font-mono">{String(i + 1).padStart(2, "0")}</div>
              <div className="text-sm text-slate-800 leading-relaxed pt-1">{f}</div>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}

function FactCard({ icon, label, value }) {
  return (
    <div className="bg-white border border-slate-200 p-4 flex items-center gap-3">
      <div className="w-10 h-10 flex items-center justify-center bg-[#F97316]/10 text-[#F97316]">{icon}</div>
      <div>
        <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500">{label}</div>
        <div className="text-sm font-bold text-[#0F2A47]">{value}</div>
      </div>
    </div>
  );
}
